import Moment from "react-moment"
import { Link, useNavigate } from "react-router-dom"
import { Likes } from "src/libs/useful"
import Bookmark from "src/libs/useful/Bookmark"
import Comments from "src/libs/useful/Comments" 
import { IAds, } from "../../data/interfaces"
import { wordTrim } from "src/libs/utilities"

interface IProps {
    item: IAds
}
const ToposSingleNews = (props: IProps) : JSX.Element => { 
    const navigate = useNavigate()
    const url : string = `modal/${props.item.land_id}/ad/${props.item.id}`
    const post_date: Date = new Date(Number(props.item.post_date) * 1000)
    const onClick = () => {
        // console.log( props.item )
    }
    const onOpen = () => {
        navigate(url)
    }
    return <div className="col-xxl-6 col-xl-12 col-lg-6 col-md-12 my-md-3 mb-1" >
        <Link to={url} className="topos-card-news text-force-contrast " onClick={onClick}>
        <div className="back card" />
        <div className="thum-cont">
            <div className="thumbnail" style={{backgroundImage: `url(${ props.item.thumbnail })`}} />
        </div> 
        <div className=" topos-card-news-content position-relative text-dark h-100">
            <div className="h-100">
                <div className=" px-3 pt-2 pb-0 h-100 d-flex flex-column position-relative">
                    <div className="text-uppercase small mb-2  opacity_75">
                        { props.item.address }
                    </div>
                    <div className="title text-uppercase " title={props.item.title} >
                        { wordTrim( props.item.title, 7) }
                    </div> 
                    {
                        !!props.item.land && <div className=" opacity_5 letter-spacing-2 small">
                            {props.item.land.title}
                        </div>
                    } 
                    <div className=" mt-2 opacity_75 small d-md-block d-none">
                        { wordTrim( props.item.post_content, 20 ) }
                    </div>
                    <div className=" position-absolute bottom left px-3 d-flex mt-auto align-items-center justify-content-between w-100">                       
                        <div className="text-uppercase small">
                            <Moment locale="ru" format="D.MM.YYYY ">
                                { post_date }
                            </Moment>
                        </div> 
                        <div className="d-flex align-items-center " onClick={(evt) => { evt.stopPropagation(); evt.preventDefault(); }} >
                            {/* <ClipboardCopyBtn
                                data={`${window.location.origin}/${getRoute(getFeedRoute("Ad"))}/${props.item.id}`}
                                type="icon"
                                label={__("Copy link")}
                                position={Position.TOP_RIGHT}
                            /> 
                            <QRCodeButton 
                                item={ props.item } 
                                options={{
                                    text:`${window.location.origin}/${getRouteByComponent("FestivalView")?.realRoute}/project/${ props.item.id }`, 
                                    title: '',
                                    width:  410,
                                    height: 410, 
                                }} 
                            /> */}
                            <Bookmark item={props.item} />  
                            <Comments item={props.item } dataType="Ad" onClick={onOpen}/>
                            <Likes item={props.item} dataType="Ad" className="" /> 
                        </div>
                    </div>               
                </div> 
            </div>
        </div>
    </Link>
    </div>
} 

export default ToposSingleNews